import { gql } from "@apollo/client";

const GET_CG_SEPC = gql`
query getCgSepc{
    cgSepcs{
      SEPC_ID
      Parastatal_Code
      Parastatal_Name    
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
      Vote_By_Sub_SubProgID {
        Vote_By_Sub_SubProgID
        Sub_SubProgramme_ID {
          Sub_SubProgramme_ID
          Sub_SubProgramme_Name
          Sub_SubProgramme_Code
          SubProgramme_ID {
            SubProgramme_ID
            SubProgramme_Code
            SubProgramme_Name
            Programme_ID
          }
        }
        Vote_ID {
          Vote_ID
          Vote_Name
          Vote_Code
        }
      }
    }
}
`;


const GET_ACTIVE_CG_SEPC = gql`
query getActiveCgSepc{
    getActiveCgSepcs{
      SEPC_ID
      Parastatal_Code
      Parastatal_Name    
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
      Vote_By_Sub_SubProgID {
        Vote_By_Sub_SubProgID
        Sub_SubProgramme_ID {
          Sub_SubProgramme_ID
          Sub_SubProgramme_Name
          Sub_SubProgramme_Code
          SubProgramme_ID {
            SubProgramme_ID
            SubProgramme_Code
            SubProgramme_Name
            Programme_ID
          }
        }
        Vote_ID {
          Vote_ID
          Vote_Name
          Vote_Code
        }
      }
    }
}
`;

const GET_CG_SEPC_GRID = gql`
query cgSEPCGridData{
    cgSEPCGridData{
      SEPC_ID
      Parastatal_Code
      Parastatal_Name
      Department_ID
      Department_Code
      Department_Name
      Sub_SubProgramme_ID
      Sub_SubProgramme_Code
      Sub_SubProgramme_Name
      SubProgramme_ID
      SubProgramme_Code
      SubProgramme_Name
      Programme_ID
      Programme_Code
      Programme_Name
      Vote_ID
      Vote_Code
      Vote_Name
      Prog_By_Vote_ID
      Vote_By_Sub_SubProgID
      Status
      Created_By
      Modified_By
      Created_Date
      Modified_Date
    }
  }
`;

const GET_USER_SEPC = gql`
  query getUserSepc($User_ID: Int!) {
    userSepc(User_ID: $User_ID) {
      SEPC_ID
      Parastatal_Code
      Parastatal_Name    
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
      Vote_By_Sub_SubProgID {
        Vote_By_Sub_SubProgID
        Sub_SubProgramme_ID {
          Sub_SubProgramme_ID
          Sub_SubProgramme_Name
          Sub_SubProgramme_Code
          SubProgramme_ID {
            SubProgramme_ID
            SubProgramme_Code
            SubProgramme_Name
            Programme_ID
          }
        }
        Vote_ID {
          Vote_ID
          Vote_Name
          Vote_Code
        }
      }
    }
  }
`;

export { GET_CG_SEPC, GET_CG_SEPC_GRID, GET_USER_SEPC , GET_ACTIVE_CG_SEPC};